import { createRouter, createWebHashHistory } from 'vue-router'

import home from '../views/Home.vue'
const login = () => import(/* webpackChunkName: "login" */ '../views/login/index.vue');
const release = () => import(/* webpackChunkName: "release" */ '../views/release/index.vue');
const appEdit = () => import(/* webpackChunkName: "release" */ '../views/release/edit.vue');
const hotUpdate = () => import(/* webpackChunkName: "release" */ '../views/hot-update/list.vue');
const download = () => import(/* webpackChunkName: "download" */ '../views/download/index.vue');
const versionList = () => import(/* webpackChunkName: "versionList" */ '../views/version-list/index.vue');

const routes = [
    {
        path: '/',
        name: 'home',
        component: home,
        meta: {
            auth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            title: '登录',
            auth: false,
        }
    },
    {
        path: '/release',
        name: 'release',
        component: release,
        meta: {
            title: '发布app',
            auth: true
        }
    },
    {
        path: '/app/edit',
        name: 'appEdit',
        component: appEdit,
        meta: {
            title: '编辑app',
            auth: true
        }
    },
    {
        path: '/hot-update',
        name: 'hotUpdate',
        component: hotUpdate,
        meta: {
            title: '热更新',
            auth: true
        }
    },
    {
        path: '/download',
        name: 'download',
        alias: '/d',
        component: download,
        meta: {
            title: 'app下载',
            auth: false
        }
    },
    {
        path: '/version-list',
        name: 'versionList',
        component: versionList,
        meta: {
            title: '版本列表',
            auth: true
        }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

export default router
